import React, { useState, useEffect, useContext } from 'react';

import * as net from "../../../lib/net";
import Wnd_Ok from "../../../lib/ui/wnd_ok";
import Td_Sel from "../../../lib/ui/td_sel";

import Kds_Add from "./kds_add";
import Kds_Edit from "./kds_edit";

class Kds_Reg extends React.Component {
  constructor(props, context) {
    super(props);

    this.store = props.store;
    this.state = {};
    this.state.zsa = [];
    this.state.tra = [];
    this.state.msg = {};
    this.state.wnds = {};
    this.state.sortid = "";
    this.state.sortdir = 1;

      if(props.wnds) {
        if(props.wnds.zsa) this.state.zsa = props.wnds.zsa;
      }
      this.selitems = [
          {fkn: 'open', text: 'ÖPPNA'},
          {fkn: 'prn', text: 'SKRIV UT'}
      ];
   }
  componentDidUpdate() {
  }
  componentWillUnmount() {
  }
  componentDidMount() {
      this.kds_list();
  }

    dlg_style() {
      var css = {};
      //css.width = window.innerWidth * 0.8;
      //css.height = window.innerHeight * 0.8;
      return css;
    }
    tab_style(tabid) {
      var css = {};
      css.display = "none";
      if(this.state.tabval === tabid) css.display = "block";
      return css;
    }
    bq_close() {
		this.props.ctx.setState({ wnds: {} });
	};
  tb_style() {
      var css = {};
      css.height = window.innerHeight - 275;
      css.overflow = "auto";
      return css;
  }
    th_style(id) {
        var css = {};
        css.cursor = "pointer";
        if(id == this.state.sortid) {
            if(this.state.sortdir) css.color = "#800";
            else css.color = "#080";
        }
        return css;
    }
    kds_list() {
    var self = this;
    var prm = {};
      //prm.req = "pms.rs.qs_rs";
      prm.req = "pos.pos_kds.kds_list";

    //gda.wndLoading("Hämtar");
    net.sio_req(prm)
    .then(function(ret){
        //alert(JSON.stringify(ret.rca));

        self.setState({rsa: ret.rca });
        self.syncTb("kdsTable");
        //toastr.success("OK", "SAPI");
    })
    .catch(function(e){
        var txt = JSON.stringify(e);
        //gda.wndError(txt);
    });
  }
  row_bong(row) {
    var self = this;
    var prm = {};
    prm.req = "pos.pos_bq.bongrow";
    prm.row = row;
    prm.status = "09";

    //gda.wndLoading("Hämtar");
    net.sio_req(prm)
    .then(function(ret){
        //alert(JSON.stringify(ret.rca));

        //self.setState({bqa: ret.rca });
        //toastr.success("OK", "SAPI");
        var msg = { ok: true, text: "BONGAD ..." };
        self.setState({msg: msg });
        setTimeout(function(){
            self.setState({msg: {} });
        }, 1000);
    })
    .catch(function(e){
        var txt = JSON.stringify(e);
        //gda.wndError(txt);
    });
  }
  prn(event) {
  }
    kds_add() {
        var self = this;

        var wnds = {};
        wnds.kdsadd = true;
        self.setState({wnds: wnds });
    }
    kds_edit(rso) {
        var self = this;

        var wnds = {};
        wnds.kdsedit = true;
        wnds.rso = rso;
        wnds.rsa = this.state.rsa;
        self.setState({wnds: wnds });
    }
    syncTb(tb) {
        if (!document.getElementById(tb)) {
            //alert("No tb");
            return;
        }
        var tbel = document.getElementById(tb);
        const thElements = tbel.getElementsByTagName('th'),
            tdElements = tbel.getElementsByTagName('td');
        if(tdElements.length < 1 ) return;

        for (let i = 0; i < thElements.length; i++) {
            const widerElement =
                    thElements[i].offsetWidth > tdElements[i].offsetWidth ? thElements[i] : tdElements[i],
                width = window.getComputedStyle(widerElement).width;
            thElements[i].style.width = tdElements[i].style.width = width;
        }
    }
    tb_sort(typ) {
        var self = this;
        //var rvs = self.state.rvs;
        var tha = self.state.tha;
        var sortid = this.state.sortid;
        var sortdir = this.state.sortdir;

        if(sortid != typ) sortdir = 0;
        else {
            if(sortdir) sortdir = 0;
            else sortdir = 1;
        }

        if(typ) {
            if(sortdir) tha.sort((a,b) => (a[typ] < b[typ]) ? 1 : ((b[typ] < a[typ]) ? -1 : 0));
            else tha.sort((a,b) => (a[typ] > b[typ]) ? 1 : ((b[typ] > a[typ]) ? -1 : 0));
        }
        self.setState({ tha: tha, sortid: typ, sortdir: sortdir });
    }
    th_icon(typ) {
        var cls = "";
        var sortid = this.state.sortid;
        var sortdir = this.state.sortdir;
        if(sortid == typ)
        {
            if(sortdir) cls = "fa fa-caret-up";
            else cls = "fa fa-caret-down";
        }
        return cls;
    }

  render() {
    //if(!this.props.wnds.rs) return "";

    var title = this.props.title;
    if(!title) title = "Titel";

	var html =
        <div className="mx_base">
        { this.props.wnds.backdrop ? <div className="mx_backdrop" /> : null }
        <div className="mx_dlg mx_90 flex-col" style={ this.dlg_style() }>
        <div className="mx_content flex">

            <div className="flex-row" style={{padding:"5px",height:"35px"}}>
                    <div className="flex-col flex">
                        <div>KDS REGISTER</div>
                    </div>
                    <div className="flex-col">
                        <div>UPPDATERA</div>
                    </div>
            </div>
            <div className="divider_orange"></div>

        <div id="kdsTable" className="web-col">
            <table className="table table-bordered table-hover tb" style={{marginBottom: "0px"}}>
                <thead>
                <tr>
                <th style={ this.th_style("kdsid") } onClick={() => this.tb_sort("kdsid") }>KDS ID <i className={ this.th_icon("kdsid") }></i></th>
                <th style={ this.th_style("text") } onClick={() => this.tb_sort("text") }>Text <i className={ this.th_icon("text") }></i></th>
                <th style={ this.th_style("ftid") } onClick={() => this.tb_sort("ftid") }>Från <i className={ this.th_icon("ftid") }></i></th>
                <th style={ this.th_style("ttid") } onClick={() => this.tb_sort("ttid") }>Till <i className={ this.th_icon("ttid") }></i></th>
                <th style={ this.th_style("max") } onClick={() => this.tb_sort("max") }>Platser <i className={ this.th_icon("max") }></i></th>
                <th style={ this.th_style("status") } onClick={() => this.tb_sort("status") }>Status <i className={ this.th_icon("status") }></i></th>
                <th></th>
                </tr>
                </thead>
            </table>
            <div className="tb-cdi" style={ this.tb_style() }>
            <table className="table table-bordered table-hover tb">
                <tbody>
                { this.state.zsa.map((row, key) =>
                <tr key={key} onDoubleClick={() => this.kds_edit(row) }>
                    <td>{ row.kdsid }</td>
                    <td>{ row.text }</td>
                    <td>{ row.ftid }</td>
                    <td>{ row.ttid }</td>
                    <td>{ row.max }</td>
                    <td>{ row.status }</td>
                    <td>
                        <Td_Sel items={ this.selitems } getValue={(e)=> this.sel_row_fkn(row, e)} />
                    </td>
                </tr>
                )}
                </tbody>
            </table>
            </div>
        </div>
        </div>

        <div className="mx_foot flex-row flex-space-between">
            <button className="btn btn-hw-red w250" onClick={() => this.bq_close() } >
                STÄNG
            </button>
            <div className="flex-row"></div>
            <button className="btn btn-hw-blue w250" onClick={() => this.kds_add() } >
                LÄGG TILL
            </button>
            <div className="flex-row"></div>
            <button className="btn btn-hw-green w250" onClick={(event) => this.prn(event) } >
                SKRIV UT
            </button>
        </div>
      </div>
            { this.state.wnds.kdsadd ? <Kds_Add wnds={this.state.wnds} ctx={this} store={this.props.store} backdrop={true} /> : null}
            { this.state.wnds.kdsedit ? <Kds_Edit wnds={this.state.wnds} ctx={this} store={this.props.store} backdrop={true} /> : null}
        <Wnd_Ok msg={this.state.msg} ctx={this} />
    </div>
	;
	return html;
  };
}

export default Kds_Reg;